const STORAGE_VERSION = "1.0.1"; // Increment this when your structure changes

export const LocalStorageService = {
  set(key, value) {
    value = { ...value};
    value._version = STORAGE_VERSION
    localStorage.setItem(key, JSON.stringify(value));
  },

  get(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    try {
      const item = JSON.parse(itemStr);

      if (!item || item._version !== STORAGE_VERSION) {
        console.warn(
          `"${key}" has outdated or missing _version. Expected "${STORAGE_VERSION}", got "${item?._version}". Removing key.`
        );
        this.remove(key);
        return null;
      }

      return item;
    } catch (error) {
      console.error(`Error parsing localStorage key "${key}"`, error);
      this.remove(key);
      return null;
    }
  },

  update(key, path, newValue) {
    let storedData = this.get(key) || {};

    if (typeof storedData !== "object" || Array.isArray(storedData)) {
      console.warn(`Cannot update "${path}" because "${key}" is not an object.`);
      return;
    }

    const keys = path.split(".");
    let current = storedData;

    for (let i = 0; i < keys.length - 1; i++) {
      const prop = keys[i];

      if (!current[prop] || typeof current[prop] !== "object") {
        current[prop] = {};
      }

      current = current[prop];
    }

    current[keys[keys.length - 1]] = newValue;

    this.set(key, storedData);
  },

  removeProperty(key, path) {
    let storedData = this.get(key);

    if (!storedData || typeof storedData !== "object" || Array.isArray(storedData)) {
      return;
    }

    const keys = path.split(".");
    let current = storedData;

    for (let i = 0; i < keys.length - 1; i++) {
      if (!current[keys[i]]) return;
      current = current[keys[i]];
    }

    delete current[keys[keys.length - 1]];
    this.set(key, storedData);
  },

  remove(key) {
    localStorage.removeItem(key);
  },

  clear() {
    localStorage.clear();
  },
};
